import { render, staticRenderFns } from "./FormElderlyPerson.vue?vue&type=template&id=216551e1&scoped=true&"
import script from "./FormElderlyPerson.vue?vue&type=script&lang=js&"
export * from "./FormElderlyPerson.vue?vue&type=script&lang=js&"
import style0 from "./FormElderlyPerson.vue?vue&type=style&index=0&id=216551e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216551e1",
  null
  
)

export default component.exports